import styled from 'styled-components'

export const ResetPasswordButtonWrapper = styled.div`
  & > button {
    width: 100%;
  }
`
